// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Poppins', sans-serif;
    
}
 .main-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 20px;
}
  
 .text-content {
    flex: 1 1;
    padding: 20px;
  }
  .text-content1 {
    flex: 1 1;
    padding: 20px;
    text-align: left;

  }
  .image-content {
    flex: 1 1;
    text-align: center; /* Center the image horizontally */
  }
  
  /* Style your text and image as needed */
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 16px;
    line-height: 1.5;
  }
  
  img {
    max-width: 70%; /* Ensure the image doesn't exceed its container width */
    max-height: 100%;
    border-radius: 6px;
  }
  
  .discover-button {
    background-color: #25274d; /* Button background color */
    color: #ffffff; /* Button text color */
    font-size: 18px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px; /* Adjust the margin as needed */
  }
  
  .discover-button:hover {
    background-color: #0056b3; /* Button background color on hover */
  }
  .sky-blue-background {
    background-color: #7bc4ff; 
    height: 500px;
  }
  
  
.bullet-points {
    list-style-type: none; 
    padding: 0;
  }
  
  .bullet-points li::before {
    content: '✔'; 
    color: #043366; 
    margin-right: 10px; 
  }
  .footer {
    padding: 20px;
    text-align: center;
    font-size: 14px;
  }
  
  @media (max-width: 768px) {
    .footer {
      font-size: 12px;
      padding: 10px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/home.css"],"names":[],"mappings":"AACA;IACI,kCAAkC;;AAEtC;CACC;IACG,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;CAEC;IACG,SAAO;IACP,aAAa;EACf;EACA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;;EAElB;EACA;IACE,SAAO;IACP,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc,EAAE,wDAAwD;IACxE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;IACvD,cAAc,EAAE,sBAAsB;IACtC,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE,gCAAgC;EACpD;;EAEA;IACE,yBAAyB,EAAE,qCAAqC;EAClE;EACA;IACE,yBAAyB;IACzB,aAAa;EACf;;;AAGF;IACI,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE;MACE,eAAe;MACf,aAAa;IACf;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap');\r\n*{\r\n    font-family: 'Poppins', sans-serif;\r\n    \r\n}\r\n .main-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 20px;\r\n}\r\n  \r\n .text-content {\r\n    flex: 1;\r\n    padding: 20px;\r\n  }\r\n  .text-content1 {\r\n    flex: 1;\r\n    padding: 20px;\r\n    text-align: left;\r\n\r\n  }\r\n  .image-content {\r\n    flex: 1;\r\n    text-align: center; /* Center the image horizontally */\r\n  }\r\n  \r\n  /* Style your text and image as needed */\r\n  h1 {\r\n    font-size: 24px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  p {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n  }\r\n  \r\n  img {\r\n    max-width: 70%; /* Ensure the image doesn't exceed its container width */\r\n    max-height: 100%;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .discover-button {\r\n    background-color: #25274d; /* Button background color */\r\n    color: #ffffff; /* Button text color */\r\n    font-size: 18px;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-top: 20px; /* Adjust the margin as needed */\r\n  }\r\n  \r\n  .discover-button:hover {\r\n    background-color: #0056b3; /* Button background color on hover */\r\n  }\r\n  .sky-blue-background {\r\n    background-color: #7bc4ff; \r\n    height: 500px;\r\n  }\r\n  \r\n  \r\n.bullet-points {\r\n    list-style-type: none; \r\n    padding: 0;\r\n  }\r\n  \r\n  .bullet-points li::before {\r\n    content: '✔'; \r\n    color: #043366; \r\n    margin-right: 10px; \r\n  }\r\n  .footer {\r\n    padding: 20px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .footer {\r\n      font-size: 12px;\r\n      padding: 10px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
